// This is here because IE and Edge don't support "focus-within" pseudo class in CSS

document.addEventListener("DOMContentLoaded", function() {
    if(/MSIE \d|Edge|Trident.*rv:/.test(navigator.userAgent)) {
        var link = document.getElementById('skip-link');
        var linkWrapper = document.getElementById('skip-link-wrapper');

        link.addEventListener('focus', function () {
            linkWrapper.style.top = 0;
        });
        link.addEventListener('focusout', function () {
            linkWrapper.removeAttribute('style');
        });
    }
});